"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UINanoProgress = _interopRequireDefault(require("UIComponents/progress/UINanoProgress"));

var _UIIconCircle = _interopRequireDefault(require("UIComponents/icon/UIIconCircle"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Video = _interopRequireDefault(require("FileManagerCore/components/icons/Video"));

var _ThumbnailVideoDuration = _interopRequireDefault(require("./ThumbnailVideoDuration"));

var _fileNameAndExtension = require("../../utils/fileNameAndExtension");

var _file = require("FileManagerCore/utils/file");

var _FileTypeIcon = _interopRequireDefault(require("FileManagerCore/components/FileTypeIcon"));

var _thumbnailTooltip = require("FileManagerCore/utils/thumbnailTooltip");

var ThumbnailSizes = _interopRequireWildcard(require("FileManagerCore/enums/ThumbnailSizes"));

var _thumbnail = require("FileManagerCore/utils/thumbnail");

var StyledFloatingButtons = (0, _styledComponents.default)(_UIButtonGroup.default).withConfig({
  displayName: "MediaThumbnailTile__StyledFloatingButtons",
  componentId: "sc-1ky3x8g-0"
})(["position:absolute;z-index:2;left:0;bottom:0;opacity:0;"]);

var StyledMediaThumbnailTile = _styledComponents.default.div.withConfig({
  displayName: "MediaThumbnailTile__StyledMediaThumbnailTile",
  componentId: "sc-1ky3x8g-1"
})(["position:absolute;display:flex;align-items:center;justify-content:center;width:100%;height:100%;left:0;top:0;background-color:", ";&:hover ", "{opacity:1;}"], _colors.GYPSUM, StyledFloatingButtons);

var StyledInsertLink = (0, _styledComponents.default)(_UILink.default).withConfig({
  displayName: "MediaThumbnailTile__StyledInsertLink",
  componentId: "sc-1ky3x8g-2"
})(["position:absolute;display:flex;align-items:center;width:100%;height:100%;left:0;top:0;justify-content:center;"]);

var StyledThumbnailImage = _styledComponents.default.img.withConfig({
  displayName: "MediaThumbnailTile__StyledThumbnailImage",
  componentId: "sc-1ky3x8g-3"
})(["max-height:100%;max-width:100%;opacity:", ";"], function (props) {
  return props.disabled ? 0.5 : 1;
});

var StyledUploadingWrapper = _styledComponents.default.div.withConfig({
  displayName: "MediaThumbnailTile__StyledUploadingWrapper",
  componentId: "sc-1ky3x8g-4"
})(["position:absolute;width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);

var StyledUploadProgress = (0, _styledComponents.default)(_UINanoProgress.default).withConfig({
  displayName: "MediaThumbnailTile__StyledUploadProgress",
  componentId: "sc-1ky3x8g-5"
})(["position:absolute;left:0;bottom:0;right:0;z-index:2;"]);

var StyledUploadingOverlay = _styledComponents.default.div.withConfig({
  displayName: "MediaThumbnailTile__StyledUploadingOverlay",
  componentId: "sc-1ky3x8g-6"
})(["position:absolute;width:100%;height:100%;opacity:0.5;cursor:progress;background-color:", ";z-index:1;"], _colors.OLAF);

var StyledBlockIcon = (0, _styledComponents.default)(_UIIconCircle.default).withConfig({
  displayName: "MediaThumbnailTile__StyledBlockIcon",
  componentId: "sc-1ky3x8g-7"
})(["z-index:2;position:absolute;top:4px;left:4px;cursor:not-allowed;"]);

var InsertDisabledIcon = function InsertDisabledIcon() {
  return _react.default.createElement(StyledBlockIcon, {
    name: "block",
    backgroundColor: _colors.OBSIDIAN,
    color: _colors.OLAF,
    size: 16,
    padding: 0,
    innerStyles: {
      transform: 'scale(1.1)',
      transformOrigin: 'center',
      lineHeight: '16px'
    }
  });
};

var MediaThumbnailTile = function MediaThumbnailTile(_ref) {
  var file = _ref.file,
      isSelected = _ref.isSelected,
      isHostAppContextPrivate = _ref.isHostAppContextPrivate,
      isUngatedForPreviewThumbnails = _ref.isUngatedForPreviewThumbnails,
      onInsert = _ref.onInsert,
      onSelect = _ref.onSelect;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      errorLoadingThumbnail = _useState2[0],
      setErrorLoadingThumbnail = _useState2[1];

  var thumbnailTitle = (0, _fileNameAndExtension.getFileNameAndExtension)(file);
  var isUploading = file.has('progress');
  var isInsertDisabled = Boolean(file.get('notSupported'));
  var showThumbnail = (0, _file.getHasThumbnail)(file);
  var showTooltip = isInsertDisabled || errorLoadingThumbnail || !(0, _thumbnailTooltip.getIsThumbnailTooltipDisabled)(file);

  var handleSelect = function handleSelect() {
    if (isSelected) {
      onSelect(null, {
        target: 'thumbnail-details-button'
      });
    } else {
      onSelect(file, {
        target: 'thumbnail-details-button'
      });
    }
  };

  var handleInsert = function handleInsert() {
    onInsert(file, {
      target: 'thumbnail-tile'
    });
  };

  var handleImageLoadError = function handleImageLoadError() {
    if (!errorLoadingThumbnail) {
      setErrorLoadingThumbnail(true);
    }
  };

  var renderFileTypeIcon = function renderFileTypeIcon() {
    return _react.default.createElement(_FileTypeIcon.default, {
      color: (0, _file.getIsVideo)(file) ? _colors.BATTLESHIP : _colors.EERIE,
      size: 32,
      file: file,
      draggable: false
    });
  };

  var renderUploadingVideoPreview = function renderUploadingVideoPreview() {
    return _react.default.createElement(StyledUploadingWrapper, {
      title: thumbnailTitle,
      "data-test-id": "thumbnail-uploading"
    }, _react.default.createElement(_Video.default, {
      size: 30
    }), _react.default.createElement(StyledUploadProgress, {
      value: file.get('progress'),
      color: _colors.CALYPSO
    }), _react.default.createElement(StyledUploadingOverlay, null));
  };

  var renderUploadingImagePreview = function renderUploadingImagePreview() {
    return _react.default.createElement(StyledUploadingWrapper, {
      title: thumbnailTitle,
      "data-test-id": "thumbnail-uploading"
    }, showThumbnail && file.get('tempUrl') ? _react.default.createElement(StyledThumbnailImage, {
      alt: thumbnailTitle,
      draggable: false,
      src: file.get('tempUrl')
    }) : renderFileTypeIcon(), _react.default.createElement(StyledUploadProgress, {
      value: file.get('progress'),
      color: _colors.CALYPSO
    }), _react.default.createElement(StyledUploadingOverlay, null));
  };

  var renderThumbnail = function renderThumbnail() {
    var thumbnailSize = isUngatedForPreviewThumbnails && (0, _thumbnail.getShouldUsePreviewSize)(file) && !(0, _file.getIsVideo)(file) ? ThumbnailSizes.PREVIEW : ThumbnailSizes.MEDIUM;
    return _react.default.createElement(StyledThumbnailImage, {
      className: "image__transparency-checkboard",
      alt: thumbnailTitle,
      draggable: false,
      onError: handleImageLoadError,
      disabled: isInsertDisabled,
      "data-test-id": "thumbnail-image",
      src: (0, _file.getImageSrc)(file, thumbnailSize, {
        isFallbackImageDisabled: true,
        shouldUpscale: true,
        fallbackSize: thumbnailSize === ThumbnailSizes.PREVIEW ? ThumbnailSizes.MEDIUM : null
      })
    });
  };

  var renderThumbnailLink = function renderThumbnailLink() {
    if (isUploading) {
      return (0, _file.getIsVideo)(file) ? renderUploadingVideoPreview() : renderUploadingImagePreview();
    }

    return _react.default.createElement(StyledInsertLink, {
      use: "unstyled",
      onClick: handleInsert,
      disabled: isInsertDisabled,
      title: thumbnailTitle,
      "data-test-id": "insert-thumbnail-link"
    }, showThumbnail && !errorLoadingThumbnail ? renderThumbnail(file, thumbnailTitle) : renderFileTypeIcon(file), (0, _file.getIsVideo)(file) && _react.default.createElement(_ThumbnailVideoDuration.default, {
      duration: file.getIn(['meta', 'duration'])
    }));
  };

  return _react.default.createElement(StyledMediaThumbnailTile, {
    "data-test-id": "thumbnail-tile"
  }, !isUploading && _react.default.createElement(StyledFloatingButtons, null, _react.default.createElement(_UIButton.default, {
    size: "extra-small",
    use: "tertiary",
    onClick: handleSelect,
    "data-test-id": "thumbnail-info-button"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "FileManagerLib.actions.fileDetail"
  }))), isInsertDisabled && _react.default.createElement(InsertDisabledIcon, null), _react.default.createElement(_UITooltip.default, {
    "data-test-id": "thumbnail-tooltip",
    disabled: !showTooltip,
    title: file.get('notSupportedReason') || _react.default.createElement(_FormattedMessage.default, {
      message: (0, _thumbnailTooltip.getThumbnailTooltipI18nKey)(file, isHostAppContextPrivate)
    }),
    placement: "left"
  }, renderThumbnailLink()));
};

MediaThumbnailTile.propTypes = {
  isSelected: _propTypes.default.bool.isRequired,
  file: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  onSelect: _propTypes.default.func.isRequired,
  onInsert: _propTypes.default.func.isRequired,
  isHostAppContextPrivate: _propTypes.default.bool.isRequired,
  isUngatedForPreviewThumbnails: _propTypes.default.bool.isRequired
};

var _default = (0, _react.memo)(MediaThumbnailTile);

exports.default = _default;
module.exports = exports.default;